import type { PropsWithChildren } from "react";
import { BuilderUI } from "@circle-react-shared/BuilderUI";

export const BuilderCanvas = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <BuilderUI.Main>
    <div className="relative [grid-area:canvas]">
      <BuilderUI.Canvas className="relative gap-3 px-3 pb-16 pt-3 [grid-area:none]">
        <BuilderUI.CanvasControls>
          <BuilderUI.CanvasSizeToggle />
        </BuilderUI.CanvasControls>
        <BuilderUI.CanvasZoomableSize>
          <BuilderUI.CanvasCard className="h-[95%]">
            {children}
          </BuilderUI.CanvasCard>
        </BuilderUI.CanvasZoomableSize>
        <BuilderUI.FullscreenPreview />
      </BuilderUI.Canvas>
    </div>
  </BuilderUI.Main>
);
